import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from '@huaca/ui';
import '@huaca/ui/styles.css';
import './styles.css';
import { config } from './config';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* webOrigin is this module's own subdomain: Google SSO and magic links return HERE, never to
        a central app. It is validated server-side against WEB_ORIGINS — an unlisted origin is
        rejected rather than reflected, which is what keeps it from being an open redirect. */}
    <AuthProvider apiBase={config.apiBase} webOrigin={config.webOrigin}>
      <App />
    </AuthProvider>
  </StrictMode>,
);
